export default __webpack_public_path__ + "static/Photo_l-dfda3ca77c59f79e2759a1583bbed3f7.png";